import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowRight, Phone } from "lucide-react";
import PageHeader from "@/components/site/PageHeader";
import { useSEO } from "@/lib/seo";
import { CITY_LIST } from "@/lib/cities";

export default function Orter() {
    useSEO({
        title: "Våra kontor — jurist i hela Sverige",
        description:
            "BM Juridik har sex kontor i Sverige: Stockholm, Göteborg, Malmö, Uppsala, Jönköping och Herrljunga. Hitta din lokala jurist.",
    });

    return (
        <div className="bg-[#0A0A0B] text-[#F4F4F5]" data-testid="page-orter">
            <PageHeader
                kicker="Våra kontor"
                title="Jurist i hela Sverige"
                description="Sex kontor — en juristbyrå. Lokal närvaro där du bor, samma höga kvalitet i hela landet."
            />

            <section className="container mx-auto px-6 lg:px-8 py-16 max-w-6xl">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {CITY_LIST.map((c, i) => (
                        <motion.div
                            key={c.slug}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.06 }}
                        >
                            <Link
                                to={`/jurist-${c.slug}`}
                                data-testid={`orter-card-${c.slug}`}
                                className="block bg-[#111113] border border-white/10 hover:border-[#C4A977]/50 p-7 rounded-sm h-full transition-colors group"
                            >
                                <div className="flex items-start justify-between">
                                    <div>
                                        <MapPin
                                            size={18}
                                            className="text-[#C4A977]"
                                        />
                                        <h2 className="mt-4 font-serif text-2xl text-[#F4F4F5] group-hover:text-[#C4A977] transition-colors">
                                            {c.name}
                                        </h2>
                                    </div>
                                    <ArrowRight
                                        size={18}
                                        className="text-[#A1A1AA] group-hover:text-[#C4A977] group-hover:translate-x-1 transition-all"
                                    />
                                </div>
                                <div className="mt-5 pt-5 border-t border-white/5 space-y-1.5 text-sm text-[#A1A1AA]">
                                    <p>{c.address}</p>
                                    <p>{c.postal}</p>
                                </div>
                                <p className="mt-5 text-xs text-[#C4A977] uppercase tracking-wider font-semibold">
                                    Jurist {c.name} →
                                </p>
                            </Link>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-16 pt-10 border-t border-white/10 text-center">
                    <p className="text-[#A1A1AA] mb-6">
                        Bor du inte nära något av våra kontor? Vi erbjuder
                        digitala möten via säker videolänk i hela Sverige.
                    </p>
                    <a
                        href="tel:+46108085613"
                        className="inline-flex items-center gap-2 text-[#C4A977] hover:text-[#DBC08F]"
                    >
                        <Phone size={14} />
                        010 - 808 56 13
                    </a>
                </div>
            </section>
        </div>
    );
}
